<template>
    <p
        v-if="dangerousHtml"
        class="line-height-3 m-0"
        v-html="body"
    />
    <p
        v-else
        class="line-height-3 m-0 whitespace-pre-wrap"
    >
        {{ body }}
    </p>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'AppAlert',

    props: {
        body: {
            type: String,
            required: true
        },
        dangerousHtml: {
            type: Boolean,
            default: false
        }
    }
})
</script>
